// Auto-generated skeleton for ReportStatus

export const ReportStatus: Api.ReportStatus = {
  id: 0,
  hp_id: null,
  name: '',
  process_step: null,
  text_color: null,
  ordering: 0,
  is_system_type: false,
};

